/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const alignJustify = (
	<SVG xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z" />
	</SVG>
);

export default alignJustify;
